<div class="b-container modal2">
    <div class="b-row header">
        <div class="b-col-12">Verify your email</div>
    </div>
    <div class="b-row">
        <div class="b-col-12">
            <div class="body ion-text-center">
                <h1 class="b-mt-3">Please enter the 6 digit code sent to</h1>
                <p class="bold ion-margin-top md-small-text">
                    {{ email }}
                </p>
                <div class="ion-text-center">
                    <ion-button fill="clear" shape="round" color="secondary" size="sm" class="secondary-action-btn" (click)="resendCode()">
                        Resend Code
                    </ion-button>
                </div>
                <input [(ngModel)]="code" class="input input-verify-width" />

                <div class="footer-center-button">
                    <div>
                        <ion-button
                            (click)="verifyCodeFromEmail()"
                            [disabled]="code.length < 6"
                            fill="solid"
                            color="secondary"
                            size="medium"
                            type="button"
                            class="default-btn"
                        >
                            Verify
                        </ion-button>
                    </div>
                </div>
                <div class="ion-text-center">
                    <ion-button fill="clear" shape="round" color="secondary" size="sm" class="secondary-action-btn" (click)="changeEmail()">
                        Change Email
                    </ion-button>
                </div>
            </div>
        </div>
    </div>
</div>
